import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store/index';

Vue.use(VueI18n);

// 함수를 사용하여 로케일 메시지들을 동적으로 불러오는 방식으로 변경
function loadLocaleMessages() {
  const requireLang = require.context('@/locales', true, /\.json$/);
  const messages = {};

  requireLang.keys().forEach(file => {
    if (file === './index.js') return;
    const path = file.replace(/(\.\/|\.json$)/g, '').split('/');
    let nestedObject = messages;
    path.forEach((key, i) => {
      if (i === path.length - 1) {
        nestedObject[key] = requireLang(file);
      } else {
        nestedObject[key] = nestedObject[key] || {};
        nestedObject = nestedObject[key];
      }
    });
  });

  return messages;
}

const defaultLocale = 'ko'; // 기본 언어 설정
let userLocale = store.state.authStore.userLanguage;

const i18n = new VueI18n({
  locale: userLocale,
  fallbackLocale: defaultLocale,
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
});

// 언어 설정을 변경하는 함수
export function setI18nLanguage(locale) {
  i18n.locale = locale; // VueI18n 인스턴스의 locale 변경
  userLocale = locale; // 사용자 언어 설정 업데이트
  store.commit('authStore/setUserLanguage', locale); // Vuex store에 사용자 언어 설정 커밋
}

export default i18n;
